export const readMoreToken = '{READMORE}'
